import React, { useState } from "react";
import HeaderItem from "./HeaderItem/HeaderItem";
import NotificationIcon from "../../../assets/icons/notification.svg";
import LanguageChangeIcon from "../../../assets/icons/language-change.svg";
import { loginActions } from "../../../store/login-slice";
import { userActions } from "../../../store/user-slice";
import { sidebarActions } from "../../../store/sidebar-slice";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import "./Header.css";
import { useNavigate } from "react-router";
import { resetHomePageProfile } from "../../../store/homepage-profile-slice";
import { resetCampaigns } from "../../../store/campaigns-slice";
import { Link } from "react-router-dom";

const Header = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [showMenu, setShowMenu] = useState(false);

  const isLogin = useSelector((state) => state.login.isLogin);

  const handleLogout = () => {
    setShowMenu(false);
    dispatch(loginActions.setIsLogin(false));
    dispatch(loginActions.setToken(false));
    dispatch(sidebarActions.setSidebar(false));
    dispatch(userActions.updateUser({ user: null, username: null }));
    localStorage.removeItem("auth");
    dispatch(resetHomePageProfile());
    dispatch(resetCampaigns());
    navigate("/auth/login");
  };

  const user = useSelector((state) => state.user.user);

  return (
    <>
      {isLogin && <nav class="navbar navbar-expand-md" id="header">
        <div class="container-fluid">
          <a class="navbar-brand" href="#"></a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          {
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav me-auto mb-2 mb-lg-0 header-items">
                {isLogin && <HeaderItem src={NotificationIcon} alt="notification-icon" />}
                <HeaderItem src={LanguageChangeIcon} alt="language-change-icon" />
                {isLogin && (
                  <li className="header-item">
                    <div className="header-profile-container">
                      <div className="header-profile-item" onClick={() => setShowMenu((state) => !state)}>
                        <img className="header-profile-img" src="/sample-profile.png" alt={user?.business_name} />
                        {/* <p>{user?.business_name}</p> */}
                      </div>
                      <KeyboardArrowDownIcon />
                      {showMenu && (
                        <div className="header-profile-menu">
                          {/* <Link to="/linked-facebook">
                            <button className="header-profile-logout">Switch Account</button>
                          </Link> */}
                          <button className="header-profile-logout" onClick={handleLogout}>
                            Log Out
                          </button>
                        </div>
                      )}
                    </div>
                  </li>
                )}
              </ul>
            </div>
          }
        </div>
      </nav>}
    </>
  );
};

export default Header;
